import Color from 'color';

const changeColorShade = (color, ratio = 0.2) => {
  const colorObj = Color(color);

  return colorObj.black() >= 65 ? colorObj.lighten(ratio).hex() : colorObj.darken(ratio).hex();
};

export default changeColorShade;
